import { getHost } from "./getHost";

export const isDevMode = (): boolean => {
  const host = getHost();
  if (host.startsWith("devx")) return true;
  if (host.startsWith("local")) return true;
  return false;
};
